import React, { useState, useEffect } from 'react';

import Response from './Response';
import TransactionField from './global/TransactionField';

function PrepaidOneTimeTopup() {
  let transDate = new Date();
  let idebitObj = {};

  if (typeof window !== 'undefined') {
    idebitObj = {
      funded: sessionStorage.getItem('funded'),
      idebit_track2: sessionStorage.getItem('idebit_track2'),
      idebit_version: sessionStorage.getItem('idebit_version'),
      idebit_issname: sessionStorage.getItem('idebit_issname'),
      idebit_isslang: sessionStorage.getItem('idebit_isslang'),
      idebit_invoice: sessionStorage.getItem('idebit_invoice'),
      idebit_amount: sessionStorage.getItem('idebit_amount'),
      idebit_issconf: sessionStorage.getItem('idebit_issconf'),
      m_data: sessionStorage.getItem('m_data'),
      profile: sessionStorage.getItem('profile'),
    };
  }

  const [paymentResponse, setPaymentResponse] = useState({});
  const [APICall, setAPICall] = useState(false);

  useEffect(() => {
    if (idebitObj.funded) {
      fetch(
        `/api/paymentIO/${idebitObj.profile}`,
        // `https://api.na.bambora.com/v1/payments/${idebitObj.m_data}/continue`,
        // `http://localhost:9080/api/payment-testing/${idebitObj.m_data}`,
        {
          method: 'post',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            payment_method: 'interac',
            interac_response: {
              idebit_track2: idebitObj.idebit_track2,
              idebit_isslang: idebitObj.idebit_isslang,
              idebit_version: idebitObj.idebit_version,
              idebit_issconf: idebitObj.idebit_issconf,
              idebit_issname: idebitObj.idebit_issname,
              idebit_amount: idebitObj.idebit_amount,
              idebit_invoice: idebitObj.idebit_invoice,
            },
            m_data: idebitObj.m_data,
          }),
        }
      )
        .then(response => response.json())
        .then(response => {
          setPaymentResponse(response.data);
          setAPICall(true);
        })
        .catch(error => {
          console.log('Request failed', error);
        });
    } else {
      setAPICall(true);
    }
  }, []);

  return (
    <div className="flex-auto">
      {idebitObj.funded === '1' && Object.keys(paymentResponse).length !== 0 && paymentResponse.constructor === Object && (
        <Response
          name="paymentMethod"
          label="Payment Method"
          isApproved={true}
          breadCrumb={[
            {
              label: 'Home',
              link: 'https://www.sasktel.com/wps/wcm/connect/content/home/',
            },
            {
              label: 'Wireless',
              link: 'https://www.sasktel.com/wps/wcm/connect/content/home/wireless/',
            },
            {
              label: 'noStrings Prepaid',
              link: 'https://www.sasktel.com/wps/wcm/connect/content/home/wireless/prepaid/',
            },
          ]}
          header="Transaction Approved"
          buttonValue="close"
          buttonOnClick={() => {
            if (idebitObj.profile === 'prepaid') {
              window.location.assign('/prepaid');
            } else if (idebitObj.profile === 'postpaid') {
              window.history.back();
            }
          }}
        >
          {idebitObj.profile === 'prepaid' && (
            <div className="font-museo font-w-300 leading-22 text-17 mb-50">
              Thanks for your order! You'll receive a confirmation text and email when your account is topped up.
            </div>
          )}
          {idebitObj.profile === 'postpaid' && (
            <div class="row mb-50 text-center">
              <p class="mb-15 md:mb-20">
                Your spending limit top-up payment has been successfully added to your account. Full service should be restored within 30 minutes.
              </p>
              <p class="mb-15 md:mb-20">
                For more information, see{' '}
                <a href="https://support.sasktel.com/app/answers/detail/a_id/17240/~/managing-your-wireless-spending-limit">
                  Managing your wireless spending limit.
                </a>
              </p>
              <p class="mb-0">
                Thank you for your order. Print this page for your records. You will also receive a confirmation via e&#8209;mail and text message.
              </p>
            </div>
          )}
          <TransactionField label="Status" content="Approved" />
          <TransactionField label="Transaction ID" content={paymentResponse.order_number} />
          <TransactionField label="Authorization code" content={paymentResponse.auth_code} />
          <TransactionField label="Billed amount" content={`\$${paymentResponse.amount.toFixed(2)} (including taxes)`} />
          <TransactionField label="Transaction date" content={`${transDate.toLocaleDateString()} ${transDate.toLocaleTimeString()}`} />
        </Response>
      )}
      {idebitObj.funded === '0' && (
        <Response
          name="paymentMethod"
          label="Payment Method"
          isApproved={false}
          breadCrumb={[
            {
              label: 'Home',
              link: 'https://www.sasktel.com/wps/wcm/connect/content/home/',
            },
            {
              label: 'Wireless',
              link: 'https://www.sasktel.com/wps/wcm/connect/content/home/wireless/',
            },
            {
              label: 'noStrings Prepaid',
              link: 'https://www.sasktel.com/wps/wcm/connect/content/home/wireless/prepaid/',
            },
          ]}
          header="Transaction Declined"
          buttonValue="close"
          buttonOnClick={() => window.history.back()}
        >
          <div className="font-museo font-w-300 leading-22 text-17 mb-50">Your transaction has been declined.</div>
          <div className="font-museo font-w-300 leading-22 text-17 mb-50">
            Please make sure you've entered your card details and personal information correctly. If the problem persists, we suggest trying another card or
            contacting your financial institution.
          </div>
          <TransactionField label="Status" content="Payment declined" />
          <TransactionField label="Transaction ID" content={paymentResponse.order_number} />
          <TransactionField label="Transaction date" content={`${transDate.toLocaleDateString()} ${transDate.toLocaleTimeString()}`} />
        </Response>
      )}
      {!idebitObj.m_data | (!paymentResponse.amount && paymentResponse.code > 634) && APICall && (
        <Response
          name="paymentMethod"
          label="Payment Method"
          isApproved={false}
          breadCrumb={[
            {
              label: 'Home',
              link: 'https://www.sasktel.com/wps/wcm/connect/content/home/',
            },
            {
              label: 'Wireless',
              link: 'https://www.sasktel.com/wps/wcm/connect/content/home/wireless/',
            },
            {
              label: 'noStrings Prepaid',
              link: 'https://www.sasktel.com/wps/wcm/connect/content/home/wireless/prepaid/',
            },
          ]}
          header="Submission Error"
          buttonValue="back"
          buttonOnClick={() => window.history.back()}
        >
          <div className="font-museo font-w-300 leading-22 text-17 mb-50">Your submission could not be processed due to the following error(s):</div>
          <div className="font-museo font-w-300 leading-22 text-17 mb-50">
            <ul className="mb-0 mt-10 list-disc list-inside mx-auto flex flex-col items-center">
              <li className="mt-10">{paymentResponse.message ? paymentResponse.message : 'Submission error'}</li>
            </ul>
          </div>
        </Response>
      )}
    </div>
  );
}

export default PrepaidOneTimeTopup;
